import { io } from 'socket.io-client';

// Initialize socket with reconnection options
const socket = io(process.env.REACT_APP_API_BASE_URL, {
  transports: ['websocket'],
  reconnection: true,
  reconnectionAttempts: Infinity,
  timeout: 10000,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
});

export const joinRoom = (room) => {
  console.log('JOINING ROOM', room);
  socket.emit('join', room);
};

socket.on('connect', () => {
  console.log('Socket connected');
});

socket.on('disconnect', (reason) => {
  console.log('Socket disconnected:', reason);
});

socket.on('reconnect', (attemptNumber) => {
  console.log(`Socket reconnected on attempt #${attemptNumber}, reloading the page...`);
  window.location.reload();
});

socket.on('error', (error) => {
  console.error('Socket encountered error:', error);
});

export const connectSocket = () => {
  console.log('Connecting to WebSocket...');
  socket.connect();
};

export default socket;
